/**
 * Thin wrappers around the unified `/images/...` and `/refine/...` API
 * endpoints, scoped to a single `image_ref`. These helpers exist so each
 * per-surface caller doesn't have to reconstruct the same URL/body shapes.
 */
import { api } from '../../utils/api';
import type {
  ApplyVariantResponse,
  GenerateImageResponse,
  GenerateVariantsResponse,
  ImageRefDTO,
} from '@historyjki/shared';

export async function generateImageForRef(
  imageRef: ImageRefDTO,
): Promise<GenerateImageResponse> {
  return api.post<GenerateImageResponse>(
    `/projects/${imageRef.project_id}/images/generate`,
    { image_ref: imageRef },
  );
}

export async function generateVariantsForRef(
  imageRef: ImageRefDTO,
): Promise<GenerateVariantsResponse> {
  return api.post<GenerateVariantsResponse>(
    `/projects/${imageRef.project_id}/images/generate-variants`,
    { image_ref: imageRef },
  );
}

/**
 * Pin a generated variant as the target's "current" image. Backed by the
 * unified `/images/apply-variant` endpoint, which knows how to overwrite a
 * page/cover key in place and how to append a new `reference_images` row
 * for ref targets — so callers don't have to switch on `image_ref.kind`.
 */
export async function applyVariantSelection(
  imageRef: ImageRefDTO,
  r2Key: string,
): Promise<ApplyVariantResponse> {
  return api.post<ApplyVariantResponse>(
    `/projects/${imageRef.project_id}/images/apply-variant`,
    { image_ref: imageRef, r2_key: r2Key },
  );
}
